import * as React from "react";
import { Seat, TimeReservationAction, Price, CartItem } from "../types";
import * as API from "../apiCalls";
import * as R from "ramda";
import useSpectacle from "./useSpectacle";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import { Context } from "../components/Context";

interface SelectorState {
  cart: CartItem[];
  selectedSeatsIds: number[];
}

function checkIfCanReserve(cart: CartItem[], seat: Seat, unumbered: boolean) {
  const ok = true;

  if (unumbered) {
    return true;
  }

  // @WYŁĄCZONE ZE WZGLĘDU NA COVID-19 BLOKADA PRZERWY W REZERWACJACH
  /* 
  cart.forEach(cartItem => {
    if (
      Math.max(...cart.map(item => item.Number)) + 2 ===
        Number.parseInt(seat.Number as any, 10) ||
      Math.min(...cart.map(item => item.Number)) - 2 ===
        Number.parseInt(seat.Number as any, 10)
    ) {
      ok = false;
    }
  }); */

  return ok;
}

export default function(
  areaPrices: { [key: string]: Price[] },
  spectacleId: number,
  unnumbered: boolean,
  state: any,
) {
  const [context, setContext] = React.useContext(Context);

  const [cartSessionToken, setSessionToken] = React.useState<string | null>(
    null,
  );

  // tslint:disable-next-line:max-line-length
  const prices: any = Object.values(areaPrices);

  const pricesGrouped = R.groupBy(R.prop("PriceId"), R.flatten(prices));

  const [reservationTimer, setReservationTimer] = React.useState(false);

  const [cartState, setCartState] = React.useState<SelectorState>({
    cart: [],
    selectedSeatsIds: [],
  });

  const unselectSeat = (id: number) => {
    API.reserveSeat(
      id,
      spectacleId,
      TimeReservationAction.UNRESERVE,
      cartSessionToken,
    )
      .then(response => {
        if (response.status === 201) {
          return response.json();
        }

        throw Error();
      })
      .then(() => {
        setCartState({
          cart: cartState.cart.filter((seat: CartItem) => seat.SeatId !== id),
          selectedSeatsIds: cartState.selectedSeatsIds.filter(
            (seatId: number) => seatId !== id,
          ),
        });
      })
      .catch(() => {
        // NOTE: Handle it more elegant
        console.log("");
      });
  };

  React.useEffect(() => {
    let timeoutId: any;
    if (reservationTimer) {
      timeoutId = setTimeout(() => {
        setCartState({
          cart: [],
          selectedSeatsIds: [],
        });

        setReservationTimer(false);
      }, 900 * 1000);
    }

    return () => clearTimeout(timeoutId);
  }, [reservationTimer]);

  const selectSeat = (id: number, seat: Seat) => {
    if (!checkIfCanReserve(cartState.cart, seat, unnumbered)) {
      return;
    }

    if (cartState.cart.length + 1 > 10) {
      return;
    }

    API.reserveSeat(
      seat.SeatId,
      spectacleId,
      TimeReservationAction.RESERVE,
      cartSessionToken,
    )
      .then(response => {
        if (response.status === 201 || unnumbered == true) {
          return response.json();
        }


        NotificationManager.warning(
          "Zostało ono właśnie zarezerwowane przez inną osobę.",
          "Nie można wybrać miejsca.",
          6000,
        );

        let updateSeats = state.seats.map((item: any) => {
          if (item.SeatId === seat.SeatId) {
            item.reserved = true;
            return item;
          } else return item;
        });

        setContext(updateSeats);

        throw Error();
      })
      .then(result => {
        if (!cartSessionToken) {
          setSessionToken(result.token);
        }

        const defaultPrice = (areaPrices as any)[
          seat.PriceAreaId.toString()
        ][0];

        if (!defaultPrice) {
          throw Error(); // NOTE: Throw error
        }

        if (cartState.selectedSeatsIds.length === 0) {
          setReservationTimer(true);
        }

        setCartState({
          cart: [
            ...cartState.cart,
            {
              SeatId: seat.SeatId,
              PriceAreaId: seat.PriceAreaId,

              Row: seat.Row,
              Number: seat.Number,
              PriceValue: Number.parseFloat(defaultPrice.Value),
              PriceId: defaultPrice.PriceId,
              PriceName: defaultPrice.Name,
              Sector: seat.Sector,
              LogicalSector: seat.LogicalSector,
            },
          ],
          selectedSeatsIds: [...cartState.selectedSeatsIds, id],
        });
      })
      .catch((error) => {
        // NOTE: Handle it more elegant
        console.log("Error", error);
      });
  };

  const changeCartItemPrice = (targetId: number, PriceId: number) => {
    //

    const updatedCart = cartState.cart.map(cartItem =>
      cartItem.SeatId === targetId
        ? {
            ...cartItem,
            PriceValue: pricesGrouped[PriceId][0].Value,
            PriceName: pricesGrouped[PriceId][0].Name,
            PriceId: pricesGrouped[PriceId][0].PriceId,
          }
        : cartItem,
    );

    setCartState({
      ...cartState,
      cart: updatedCart,
    });
  };

  const isSeatSelected = (id: number) => {
    return cartState.selectedSeatsIds.includes(id);
  };

  return {
    cart: cartState.cart,
    cartSessionToken,
    selectSeat,
    unselectSeat,
    isSeatSelected,
    changeCartItemPrice,
    reservationTimer,
  };
}
